export default () => {
  window.FloatingNavigationHelpers.openMenu();
};
